"use client"

import { Cast } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CastIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CastIcon = component(Icon)({ as: Cast })
